
const priceTypes = {
    setPriceList: 'SET_PRICE_LIST',
};

export default priceTypes;